import { useLocation } from "react-router-dom";

// Site-wide ambient smoke: many individual "joint" curls rising from the bottom
// of the viewport — thin lively wisps that serpentine as they climb, staggered
// so several are always visible. Pure CSS transform/opacity (GPU-only).
// Desktop = 12 wisps, tablet = 9, phones = 6. Hidden for reduced motion.
const WISPS = [
    { left: "2%", width: 205, dur: 17, delay: -2, peak: 0.5, flip: 1, sway: "3vw", show: "" },
    { left: "9%", width: 180, dur: 22, delay: -13, peak: 0.42, flip: -1, sway: "-3vw", show: "hidden md:block" },
    { left: "16%", width: 225, dur: 19, delay: -6, peak: 0.46, flip: 1, sway: "2.5vw", show: "hidden lg:block" },
    { left: "24%", width: 190, dur: 21, delay: -10, peak: 0.44, flip: -1, sway: "-2.5vw", show: "" },
    { left: "32%", width: 215, dur: 16, delay: -4, peak: 0.48, flip: 1, sway: "3vw", show: "hidden md:block" },
    { left: "41%", width: 185, dur: 23, delay: -16, peak: 0.4, flip: -1, sway: "-3vw", show: "" },
    { left: "50%", width: 220, dur: 18, delay: -8, peak: 0.5, flip: 1, sway: "2.5vw", show: "hidden lg:block" },
    { left: "58%", width: 175, dur: 20, delay: -3, peak: 0.44, flip: -1, sway: "-2.5vw", show: "" },
    { left: "66%", width: 210, dur: 15, delay: -11, peak: 0.48, flip: 1, sway: "3vw", show: "hidden md:block" },
    { left: "74%", width: 190, dur: 22, delay: -7, peak: 0.42, flip: -1, sway: "-3vw", show: "" },
    { left: "82%", width: 230, dur: 17, delay: -14, peak: 0.46, flip: 1, sway: "2.5vw", show: "" },
    { left: "91%", width: 180, dur: 21, delay: -5, peak: 0.44, flip: -1, sway: "-2.5vw", show: "hidden lg:block" },
];

export default function AmbientSmoke() {
    const { pathname } = useLocation();
    if (pathname.startsWith("/admin")) return null;

    return (
        <div
            data-testid="ambient-smoke"
            className="ambient-smoke-layer pointer-events-none fixed inset-0 z-[30] overflow-hidden"
            aria-hidden="true"
        >
            {WISPS.map((w, i) => (
                <img
                    key={i}
                    src="/images/smoke-ambient.png"
                    alt=""
                    className={`joint-smoke ${w.show}`}
                    style={{
                        left: w.left,
                        width: w.width,
                        "--dur": `${w.dur}s`,
                        "--delay": `${w.delay}s`,
                        "--peak": w.peak,
                        "--sway": w.sway,
                        "--flip": w.flip,
                    }}
                />
            ))}
        </div>
    );
}
